export default __webpack_public_path__ + "static/media/thankyou1.6a56b8b1.png";